require('./common');
const trackController = require('./track/controller/trackController');
const analyticsModal = require('./track/models/analyticsModel');

const proLink = {
  init: function () {
    this.section = document.getElementById('js-proLink');
    this.btn = document.getElementById('js-proLinkButton');
    if (this.section) {
      this.renderText();
      this.renderBlock();
      this.display(this.section, 'flex');
      this.checkState && this.form.init();
      this.resizeListener();
    }
  },
  checkState: function () {
    return localStorage.getItem('proLink');
  },
  renderText: function () {
    this.section.querySelectorAll('[data-un]').forEach(e => {
      e.textContent = this.checkState() ? e.dataset.au : e.dataset.un;
    });
    this.renderMobileDataView();
  },
  renderBlock: function () {
    this.display(document.getElementById(this.checkState() ? "js-proLinkButton" : "js-proLinkForm"), this.checkState() ? "flex" : "block");
    this.display(document.getElementById(this.checkState() ? "js-proLinkForm" : "js-proLinkButton"), "none");
  },
  display: function (target, type) {
    target.style.display = type;
  },
  renderMobileDataView: function () {
    const width = window.innerWidth;
    this.section.querySelectorAll('[data-mob-text]').forEach(e => {
      e.innerHTML = width < 768 ? e.dataset.mobText : (e.dataset.deskText ? e.dataset.deskText : (this.checkState() ? e.dataset.au : e.dataset.un));
    });
    this.section.querySelectorAll('[data-mob-link]').forEach(e => {
      e.href = width < 768 ? e.dataset.mobLink : e.dataset.deskLink;
    });
  },
  resizeListener: function () {
    this.renderMobileDataView();

    window.addEventListener("resize", () => {
      this.renderMobileDataView();
    });
  },
  form: {
    sendEvents: function (status, err) {
      analyticsModal(status, "SCOUT_EXT_PRO", err);
    },
    init: function () {
      this.form = document.getElementById('js-proLinkForm');
      this.listener();
    },
    saveState: function () {
      localStorage.setItem("proLink", "completed");
    },
    decline: function (err, placeHolderText) {
      this.sendEvents(false, err);
      this.inp.classList.add('error');
      this.inp.placeholder = placeHolderText;
      this.inp.value = "";
    },
    send: function (email) {
      const body = {
        "type": '11',
        "email": localStorage.getItem('errorEmail') || email
      }
      trackController(body)
        .then((response) => {
          if (response.ok) {
            this.sendEvents(true);
            this.saveState();
            proLink.btn.click();
            proLink.renderText();
            proLink.renderBlock();
          }
        })
        .catch(err => {
          this.decline(err, "Something went wrong. Please try again.");
        });
    },
    listener: function () {
      this.form.addEventListener('click', e => {
        if (e.target.tagName === "BUTTON") {
          this.inp = e.target.previousElementSibling;
          if (emailIsValid(this.inp.value)) {
            this.send(this.inp.value);
          } else {
            this.decline(this.inp.value.length > 0 ? "Email Validation Failed" : "Empty Input", !this.inp.value.length > 0 ? "Please enter your email" : "Your email address is invalid");
          }
        }
      });
    }
  }
}

module.exports = proLink;